import { render, staticRenderFns } from "./order2.vue?vue&type=template&id=a0884c92&scoped=true&"
import script from "./order2.vue?vue&type=script&lang=js&"
export * from "./order2.vue?vue&type=script&lang=js&"
import style0 from "./order2.vue?vue&type=style&index=0&id=a0884c92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0884c92",
  null
  
)

export default component.exports